import React from 'react';
import { Navigate,useParams } from 'react-router-dom';
import UsuarioService from './app/services/usuarioExternoService';
import { useVerificaPermissao } from './app/shared/useVerificaPermissao';

interface ProtectedRoutesProps {
  children: React.ReactNode;
}

const usuarioService = new UsuarioService();

const PrivateRoute: React.FC<ProtectedRoutesProps> = ({ children }) => {
  useVerificaPermissao();
  const { slug } = useParams();
  const usuarioAutenticado = usuarioService.usuarioAutenticado();
   if (usuarioAutenticado) {
    return <>{children}</>;
  } else {
const redirectPath = slug ? `/${slug}/login` : '/login';
return <Navigate to={redirectPath} replace />;
  }
};

export default PrivateRoute;
